import React, {useEffect, useState} from 'react';
import Pane from "../../../Components/Pane";
import Text from "../../../Components/Text";
import InvisiblePane from "../../../Components/InvisiblePane";
import Button from "../../../Components/Button";
import PrimaryTitle from "../../../Components/PrimaryTitle";
import AgentPanel from "../../../Components/AgentPanel";
import {JOURNEYS, prependJourneyToRouteName} from "../../../constants";
import PageLoadingPanel from "../../../Components/PageLoadingPanel";
import ProgressBar from "../../../Components/ProgressBar";

const CongratulationsPage = (props) => {
    const {
        journey = JOURNEYS.AGENT
    } = props;

    const PAGE_TITLE            = 'Process Complete';
    const CURRENT_STEP_NUMBER   = 4;
    const TOTAL_STEP_NUMBER     = 4;

    const [data, setData]       = useState({

    });
    const [loaded, setLoaded]   = useState(false);

    useEffect(() => {
        load();
    }, []);

    const load = () => {
        axios.get(route(prependJourneyToRouteName(journey, 'session.congratulations.get'), {session: window.session}).toString())
            .then((response) => {
                if (!!response && !!response.data) {
                    setData(response.data);
                }
            })
            .catch((error) => {
                console.log(error);
            }).finally(() => {
            setLoaded(true);
        });
    }

    const renderText = () => {
        if (journey === JOURNEYS.MANGO) {
            return (
                <>
                    <Text>We’ve received the customer application.</Text>
                    <Text>They will receive an email within the next hour to continue setting up their account.</Text>
                    <Text style={{marginBottom: '0'}}>They will only need to verify their email, set a password and login to being using SB Pro.</Text>
                </>
            )
        }

        return (
            <>
                <Text>We’ve received the customer application.</Text>
                <Text>They will receive an email within the next hour to continue setting up their account and a call agent will contact them to verify their application.</Text>
                <Text style={{marginBottom: '0'}}>They will need to verify their email, set a password and login to being using SB Pro.</Text>
            </>
        )
    }

    if (!loaded) {
        return (
            <PageLoadingPanel
                pageTitle={PAGE_TITLE}
                currentStepNumber={CURRENT_STEP_NUMBER}
                totalStepNumber={TOTAL_STEP_NUMBER}
                upperTextComponent={null}
            />
        )
    }

    return (
        <React.Fragment>
            <Pane>
                <ProgressBar
                    title={PAGE_TITLE}
                    currentStepNumber={CURRENT_STEP_NUMBER}
                    totalStepNumber={TOTAL_STEP_NUMBER}
                />
                <PrimaryTitle>{PAGE_TITLE}</PrimaryTitle>
                <Text>The payment has been successful.</Text>
                {renderText()}
            </Pane>
            <InvisiblePane style={{paddingTop: '59px', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Button
                    label={'Start again'}
                    disabled={false}
                    onClick={() => {
                        window.location.href = route(journey+'.session.missing', {agent: window.agent}).toString();
                    }}
                />
            </InvisiblePane>
            <AgentPanel journey={journey} />
        </React.Fragment>
    );
}

export default CongratulationsPage;
